export default [{
  path: '/administracao/logs-aplicacao',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Logs da Aplicação',
      path: '',
      component: () => import('@/views/logsAplicacao/index.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: 'Administração', path: '/administracao' },
          { name: 'Logs da Aplicação' }
        ]
      }
    }
  ]
}]